module.exports = __webpack_public_path__ + "static/fonts/iconfont.b6610c9f.woff2";